import React, { FC, useContext, useEffect, useState } from 'react';
import { Modal, Button } from 'esa-ui-library';
import { AuthContext } from '../../../../../logic';
import { getPartnerSkinPrefs, setPartnerSkinPrefs } from '../../../../../api';
import { PERMISSIONS } from '../../../../constants';
import styles from './PartnerSkinPrefs.module.scss';

interface PartnerSkinPrefsProps {
	partnerId: number;
	partnerName: string;
	partner: string;
	onClose: () => void;
}

const PartnerSkinPrefs: FC<PartnerSkinPrefsProps> = ({ partnerId, partnerName, partner, onClose }): JSX.Element => {
	const { token, user } = useContext(AuthContext);
	const [prefs, setPrefs] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(true);
	const [updating, setUpdating] = useState<boolean>(false);

	const canSetSkinPrefs = user?.permissions[PERMISSIONS.canSetSkinPrefs];

	useEffect(() => {
		const fetchPrefs = async () => {
			try {
				const response: any = await getPartnerSkinPrefs({ token, partner_id: partnerId });
				if (response?.data) {
					setPrefs(JSON.stringify(response.data.return, null, 2));
				}
			} catch (error) {
				//
			} finally {
				setLoading(false);
			}
		};

		fetchPrefs();
	}, [partnerId, token]);

	const handleUpdate = async () => {
		let parsedPrefs;
		try {
			parsedPrefs = JSON.parse(prefs);
		} catch (e) {
			alert('Invalid JSON format');
			return;
		}

		setUpdating(true);
		try {
			await setPartnerSkinPrefs({
				token,
				partner_id: partnerId,
				pref: parsedPrefs,
			});
			alert('Partner skin preferences updated successfully');
			onClose();
		} catch (error) {
			//
			alert('Failed to update partner skin preferences');
		} finally {
			setUpdating(false);
		}
	};

	return (
		<Modal
			title={`Partner Skin Prefs - ${partner} (${partnerName}) - Skin ID: ${partnerId}`}
			onCancel={onClose}
			onSubmit={onClose}
			submitLabel='Close'
		>
			<div className={styles.PartnerSkinPrefs}>
				{loading ? (
					<p>Loading...</p>
				) : (
					<>
						<textarea value={prefs} onChange={(e) => setPrefs(e.target.value)} spellCheck={false} disabled={updating} />
						<div className={styles.Actions}>
							{canSetSkinPrefs && (
								<Button
									title={updating ? 'Updating...' : 'Update'}
									onClick={handleUpdate}
									disabled={updating || loading}
								/>
							)}
						</div>
					</>
				)}
			</div>
		</Modal>
	);
};

export { PartnerSkinPrefs };
